import { render, staticRenderFns } from "./_triplet_detail.vue?vue&type=template&id=2e0855b4&"
import script from "./_triplet_detail.vue?vue&type=script&lang=js&"
export * from "./_triplet_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports